import React from 'react';
import { Row } from 'antd';
import type { RowProps as AntRowProps } from 'antd';
import type { BaseComponentProps } from '../../types/common';

export interface AndRowProps extends AntRowProps, BaseComponentProps {}

export const AndRow: React.FC<AndRowProps> = ({
  id, sessionId, develop, children, ...restProps
}) => {
  return <Row {...restProps}>{children}</Row>;
};

export default AndRow;
